import { useUserPrefs } from "@/hooks/useUserPrefs";
import { translateKey } from "../ts/translateKey";


export const useTranslate = () => {
	
	const {
		lang,
	} = useUserPrefs();

	const translate = (key:string) => {
		return translateKey(key, lang.value);
	};

	return {
		translate
	};
};